import { useState } from "react";
import { Menu, X } from "lucide-react";
import logo from "../assets/cornerlogo.jpg";

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <nav className="absolute top-0 left-0 w-full px-4 pt-4 z-50">

      {/* FLOATING NAVBAR CONTAINER */}
      <div
        className="
          max-w-6xl
          mx-auto
          px-5
          sm:px-7
          bg-[#f5eee6]
          border
          border-[#e7ddd2]
          rounded-full
          shadow-lg
        "
      >

        {/* MAIN ROW */}
        <div className="flex items-center justify-between h-[72px]">

          {/* LEFT - LOGO */}
          <a href="#home" className="flex items-center gap-3 group">

            <img
              src={logo}
              alt="Moffee Magic"
              className="h-10 w-10 object-cover rounded-full border border-white/10"
            />

            <span className="relative">

              <span className="text-[#2b1d17] text-xl font-medium tracking-wide group-hover:text-[#d68c45] transition duration-300">
                Moffee Magic
              </span>

              <span className="absolute left-0 -bottom-1 w-0 h-[3px] bg-[#d68c45] rounded-full transition-all duration-300 group-hover:w-full"></span>

            </span>

          </a>

          {/* DESKTOP MENU */}
          <div className="hidden md:flex items-center gap-12 text-[#2b1d17]/80 text-[15px] font-medium">

            {["Home", "Products", "Contact"].map((item) => (
              <a
                key={item}
                href={`#${item.toLowerCase()}`}
                className="relative group"
              >

                <span className="group-hover:text-[#d68c45] transition duration-300">
                  {item}
                </span>

                <span className="absolute left-0 -bottom-1 w-0 h-[2px] bg-[#d68c45] transition-all duration-300 group-hover:w-full"></span>

              </a>
            ))}

          </div>

          {/* RIGHT SIDE */}
          <div className="flex items-center gap-4">

            {/* CTA BUTTON */}
            <a
              href="#products"
              className="
                hidden
                md:inline-flex
                items-center
                bg-[#d68c45]
                hover:bg-[#bf7a35]
                text-black
                px-6
                py-3
                rounded-full
                font-medium
                transition
                duration-300
                hover:scale-105
              "
            >
              Buy Now
            </a>

            {/* MOBILE ICON */}
            <div
              className="md:hidden text-[#2b1d17] cursor-pointer"
              onClick={() => setOpen(!open)}
            >
              {open ? <X size={28} /> : <Menu size={28} />}
            </div>

          </div>

        </div>

      </div>

      {/* MOBILE MENU */}
      <div
        className={`
          md:hidden
          max-w-6xl
          mx-auto
          mt-3
          bg-[#f5eee6]
          rounded-3xl
          overflow-hidden
          transition-all
          duration-300
          border border-[#e7ddd2]
          shadow-lg
          ${
            open
              ? "max-h-80 py-6 opacity-100"
              : "max-h-0 opacity-0"
          }
        `}
      >

        {/* MOBILE LINKS */}
        <div className="flex flex-col items-center gap-6 text-[#2b1d17] text-lg">

          {["Home", "Products", "Contact"].map((item) => (
            <a
              key={item}
              href={`#${item.toLowerCase()}`}
              onClick={(e) => {
                e.preventDefault();

                const section = document.getElementById(
                  item.toLowerCase()
                );

                // CLOSE MENU FIRST
                setOpen(false);

                // THEN SCROLL
                setTimeout(() => {
                  section?.scrollIntoView({
                    behavior: "smooth",
                  });
                }, 100);
              }}
              className="hover:text-[#d68c45] transition duration-300"
            >
              {item}
            </a>
          ))}

          {/* MOBILE CTA */}
          <a
            href="#products"
            onClick={() => setOpen(false)}
            className="
              bg-[#d68c45]
              hover:bg-[#bf7a35]
              text-black
              px-6
              py-3
              rounded-full
              font-medium
              transition
              duration-300
            "
          >
            Buy Now
          </a>

        </div>

      </div>

    </nav>
  );
}